var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { ComposersDocument } from './query.gql';
export const useComposers = (composerIds) => {
    const _a = useQuery(ComposersDocument, {
        variables: { composerIds },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { composers = [] } = data || {};
    const transformedComposers = composers.map((composer) => {
        var _a, _b;
        return ({
            id: composer.id,
            metadata: composer.metadata,
            defaultSigners: (((_a = composer.defaultSignatories) === null || _a === void 0 ? void 0 : _a.signatories) || []).map((signatory) => (Object.assign(Object.assign({}, signatory), { type: EsigningRecipientType.Signatory, name: `${signatory.firstName} ${signatory.lastName}`, title: signatory.title || undefined, label: signatory.label || undefined, mobile: signatory.mobile || undefined, createdAt: signatory.createdAt || undefined, updatedAt: signatory.updatedAt || undefined }))),
            defaultViewers: (((_b = composer.defaultSignatories) === null || _b === void 0 ? void 0 : _b.ccRecipients) || []).map((ccRecipient) => (Object.assign(Object.assign({}, ccRecipient), { type: EsigningRecipientType.Viewer, name: `${ccRecipient.firstName} ${ccRecipient.lastName}`, label: ccRecipient.label || undefined, createdAt: ccRecipient.createdAt || undefined, updatedAt: ccRecipient.updatedAt || undefined }))),
        });
    });
    const normalizedComposers = transformedComposers.map((composer) => ({
        id: composer.id,
        metadata: composer.metadata,
        defaultRecipients: [...composer.defaultSigners, ...composer.defaultViewers],
    }));
    return Object.assign({ composers: normalizedComposers }, rest);
};
